module.exports = __webpack_public_path__ + "img/header-xl.7f6090da.png";